import { render, staticRenderFns } from "./VuesticTag.vue?vue&type=template&id=5f162a91"
import script from "./VuesticTag.vue?vue&type=script&lang=js"
export * from "./VuesticTag.vue?vue&type=script&lang=js"
import style0 from "./VuesticTag.vue?vue&type=style&index=0&id=5f162a91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports